/**
 * Constants for tracking search filter categories
 */

export const ALLOWED_SEARCH_FILTER_CATEGORY_TYPES = [
  "sponsor_company_location",
  "company_activity",
  "company_relationship",
  "trial_phases",
  "user_lists",
  "trial_status",
  "organizations",
  "conditions",
  "therapies"
];


export const COMPANY_ACTIVITY_CATEGORY_TO_LABEL = Object.freeze({
  clin_movements: "milestone",
  opinion: "opinion",
  results_n_data: "results",
  cf_finding: "funding",
  partnering: "partnering",
  the_rest: "other",
});
